import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { MdDelete } from "react-icons/md";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  deleteExportSalesOrder,
  getAllExportSalesOrder,
} from "./services/exporSalesOrder.services";
import { setExportSalesOrderDetailsID } from "./exportSalesOrderSlice";
import { useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { FaPrint } from "react-icons/fa";

const ExportSalesOrder: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(closed());
      dispatch(setCurrentPage(0));
    };
  }, []);

  const handleCreate = () => {
    navigate("/exportsalesorder/create");
  };

  return (
    <>
      <DeleteExportSalesOrderDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 20px 20px 0",
          }}
        >
          <p className="fs-4" style={{ margin: 0, fontWeight: "bold" }}>
            Export Sales Order
          </p>
          {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Add New"}
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <ExportSalesOrderGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ExportSalesOrderGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const navigate = useNavigate();
  // const FilterCustomExpenseDetails: any = useAppSelector(
  //   (state) => state.expensedetails.FilterCustomExpenseDetails
  // );
  const ExportSalesOrderList = useAppSelector(
    (state) => state.exportsalesorder.ExportSalesOrderList
  );
  const loading = useAppSelector((state) => state.exportsalesorder.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  useEffect(() => {
    const fetchItemList = async () => {
      const payload = {
        // ...FilterCustomExpenseDetails,
        // sr_id: Number(localStorage.getItem("UserID")),
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      await dispatch(getAllExportSalesOrder(payload));
    };
    fetchItemList();
  }, [currentPage, pageLimit]);

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (id: string) => {
      dispatch(openDialog("deleteExportSalesOrder"));
      dispatch(setExportSalesOrderDetailsID(id));
    };
    const handleEdit = (id: number, pono: string) => {
      navigate("/exportsalesorder/edit", {
        state: {
          ExportSalesOrderID: id,
          PONO: pono,
        },
      });
    };
    const handlePrintExportSO = (export_sales_order_guid: string) => {
      window.open(`/exportsalesorderprint/${export_sales_order_guid}`);
    };

    return (
      <td
        className={`action-td ${props.className}`}
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => handleEdit(props.dataItem.id, props.dataItem.pono)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() => handleOpenDeleteDialog(props.dataItem.id)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Print"
            onClick={() =>
              handlePrintExportSO(props.dataItem?.export_sales_order_guid)
            }
          >
            <FaPrint
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 4 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        className="responsive-table"
        filterable={true}
        filter={filter}
        data={
          filter ? filterBy(ExportSalesOrderList, filter) : ExportSalesOrderList
        }
        onFilterChange={handleFilterChange}
        total={
          ExportSalesOrderList[0]?.item_count || ExportSalesOrderList?.length
        }
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column width={150} field="pono" filterable={false} title="Po. No." />
        <Column
          width={200}
          field="po_date"
          // filterCell={CommonFilterCell}
          title="Po. Date"
        />
        <Column
          field="party_name"
          title="Party Name"
          filterable={false}
          width={250}
        />
        <Column
          width={200}
          field="exp_delivery_date"
          // filterCell={CommonFilterCell}
          title="Exp Delivery Date"
        />
        {(isEditAccess || isDeleteAccess || isPrintAccess) && (
          <Column
            field="id"
            title="Actions"
            cell={MyEditCommandCell}
            width={"140px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeleteExportSalesOrderDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const ExportSalesOrderDetailsID = useAppSelector(
    (state) => state.exportsalesorder.ExportSalesOrderDetailsID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  // const FilterCustomExpenseDetails: any = useAppSelector(
  //   (state) => state.expensedetails.FilterCustomExpenseDetails
  // );

  const handleDeleteAction = async (ID: any) => {
    if (ID) {
      const response = await dispatch(deleteExportSalesOrder(ID));
      const payload = {
        // ...FilterCustomExpenseDetails,
        // sr_id: Number(localStorage.getItem("UserID")),
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllExportSalesOrder(payload));
        dispatch(closeDialog());
        dispatch(setExportSalesOrderDetailsID(null));
      } else {
        dispatch(getAllExportSalesOrder(payload));
        dispatch(closeDialog());
        dispatch(setExportSalesOrderDetailsID(null));
      }
    }
  };

  return (
    <>
      {dialogName === "deleteExportSalesOrder" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Export Sales Order?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Export Sales Order?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ExportSalesOrderDetailsID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

// const CommonFilterCell = (props: any) => {
//   const dispatch = useAppDispatch();
//   const currentPage = useAppSelector((state) => state.pagination.currentPage);
//   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
//   const FilterCustomExpenseDetails: any = useAppSelector(
//     (state) => state.expensedetails.FilterCustomExpenseDetails
//   );
//   const isFilterRef = useRef(true);
//   const [inputValue, setInputValue] = useState(props.value || "");
//   const [inputField, setInputField] = useState(props.field || "");

//   const onChange = (event: any) => {
//     setInputValue(event.target.value);
//     setInputField(event.target.name);
//   };

//   const delayedApiCall = React.useCallback(
//     _debounce((updatedFilters: any) => {
//       dispatch(setCurrentPage(0));
//       const payload = {
//         ...updatedFilters,
//         sr_id: Number(localStorage.getItem("UserID")),
//         limit: +pageLimit,
//         skip: +currentPage * +pageLimit,
//       };

//       dispatch(getAllExportSalesOrder(payload));
//     }, 300),
//     [dispatch]
//   );

//   useEffect(() => {
//     if (!isFilterRef.current) {
//       const updatedFilters = {
//         ...FilterCustomExpenseDetails,
//         [inputField]: inputValue,
//       };
//       dispatch(setFilterCustomExpenseDetails(updatedFilters));
//       delayedApiCall(updatedFilters);
//     } else {
//       isFilterRef.current = false;
//     }
//     return () => {
//       delayedApiCall.cancel();
//     };
//   }, [inputValue, delayedApiCall]);

//   const onClearButtonClick = (event: any) => {
//     event.preventDefault();
//     props.onChange({
//       value: null,
//       operator: "",
//       syntheticEvent: event,
//     });

//     const updatedFilters = { ...FilterCustomExpenseDetails, [props.field]: "" };
//     dispatch(setFilterCustomExpenseDetails(updatedFilters));

//     const payload = {
//       ...updatedFilters,
//       sr_id: Number(localStorage.getItem("UserID")),
//       limit: +pageLimit,
//       skip: +currentPage * +pageLimit,
//     };

//     dispatch(getAllExportSalesOrder(payload));
//   };

//   return (
//     <div className="d-flex">
//       <TextBox
//         value={FilterCustomExpenseDetails[props.field] || ""}
//         name={props.field || ""}
//         onChange={onChange}
//       />
//       <Button
//         svgIcon={filterClearIcon}
//         title="Clear"
//         disabled={!FilterCustomExpenseDetails[props.field]}
//         onClick={onClearButtonClick}
//         type="button"
//         style={{
//           marginLeft: "8px",
//         }}
//       ></Button>
//     </div>
//   );
// };

export default ExportSalesOrder;
